import React from 'react';
import Push2FAPrompt from './Push2FAPrompt';
import useSensitive2FAGate from '../hooks/useSensitive2FAGate';

/**
 * Wraps sensitive tab content (Dokumente / Postfach). If the user has push 2FA
 * enabled and has NOT verified within the last 30 minutes, shows a step-up
 * challenge. Otherwise renders children.
 */
export default function Sensitive2FAGate({ user, tabName, label, children }) {
  const gate = useSensitive2FAGate(user, tabName);

  if (gate.unlocked) return <>{children}</>;

  return (
    <div className="card max-w-md mx-auto p-6 space-y-5" data-testid={`sensitive-gate-${tabName}`}>
      {!gate.challenge ? (
        <>
          <div className="text-center">
            <div
              className="inline-flex items-center justify-center mb-4 rounded-full"
              style={{
                width: 72,
                height: 72,
                background: 'linear-gradient(145deg, #C5A059, #B0904F)',
              }}
            >
              <svg className="w-9 h-9 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-primary">Identitätsprüfung erforderlich</h3>
            <p className="text-sm text-muted-foreground mt-2">
              Aus Sicherheitsgründen musst du dich vor dem Zugriff auf{' '}
              <strong>{label}</strong> erneut bestätigen.
            </p>
          </div>
          {gate.error && (
            <p className="text-sm text-red-600 text-center" data-testid={`sensitive-gate-error-${tabName}`}>
              {gate.error}
            </p>
          )}
          <button
            onClick={gate.requestAccess}
            className="btn-primary w-full"
            data-testid={`sensitive-gate-start-${tabName}`}
          >
            Bestätigung anfordern
          </button>
        </>
      ) : (
        <Push2FAPrompt
          challengeToken={gate.challenge.token}
          numberCode={gate.challenge.number}
          ttlSeconds={gate.challenge.ttl_seconds}
          onApproved={() => { /* gate hook flips unlocked */ }}
          onDenied={gate.cancel}
          onExpired={gate.cancel}
          onCancel={gate.cancel}
        />
      )}
    </div>
  );
}
